import classNames from 'classnames';
import { PropsWithChildren } from 'react';

import { PropsWithClassname } from '@/app/types';

import Link from 'next/link';

interface DonationFormHeadingProps extends PropsWithChildren<PropsWithClassname> {
  href?: string;
}

const DonationFormHeading = ({ children, href, className }: DonationFormHeadingProps) => {
  return (
    <h1
      className={classNames(
        className,
        'w-full text-center inline-block text-[24px] lg:text-[32px] leading-[32px] lg:leading-[40px] font-medium text-neutral-dark ',
      )}
    >
      <Link href={href ?? '#'} prefetch={process.env.NEXT_PUBLIC_PREFETCH_LINKS === 'true'}>
        {children}
      </Link>
    </h1>
  );
};

export default DonationFormHeading;
